import { MessageReaction, UserChatMessageProps } from "../types";
import { ReactionTypeEntity } from "../../../services/gc/types/reactionTypeEntity";
import { Message, PresenceMember } from "@ably/chat";
import { timeAgo } from "../../../utils/time";
import { memo } from "react";
import { ChatMessageContent } from "./ChatMessageContent";

export const ChatMessage = memo(
  ({
    deleteMessage,
    toggleReaction,
    message,
    members,
    compact,
  }: {
    deleteMessage: (message: Message) => void;
    toggleReaction: (message: Message, data: ReactionTypeEntity) => void;
    message: Message;
    members: Record<string, PresenceMember>;
    compact?: boolean;
  }) => {
    const { clientId, createdAt: timestamp } = message;
    const reactions = message.metadata.reactions as Record<
      string,
      MessageReaction[]
    >;
    const memberData = members[clientId];
    const metadata = { ...message.metadata, ...(memberData?.data ?? {}) };
    const { username, avatar, isGold, isAdmin, isGuest, guestIcon } =
      metadata as UserChatMessageProps;
    const formattedDate = timeAgo(timestamp.getTime());

    const handleChatDelete = () => {
      deleteMessage(message);
    };

    const handleChatReaction = (data: ReactionTypeEntity) => {
      toggleReaction(message, data);
    };

    return (
      <ChatMessageContent
        compact={compact}
        username={username ?? ""}
        date={formattedDate ?? ""}
        text={message.text}
        isGold={isGold}
        isGuest={isGuest}
        isAdmin={isAdmin}
        guestIcon={guestIcon}
        avatar={avatar}
        isOnline={
          members[clientId] ? members[clientId]?.action !== "leave" : false
        }
        reactions={reactions}
        handleDelete={handleChatDelete}
        handleReaction={handleChatReaction}
      />
    );
  },
);
